import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCross = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M6 6L18 18",
		stroke: "#212629",
		strokeWidth: 1.5,
		strokeLinecap: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M6 18L18 5.99998",
		stroke: "#212629",
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})]
});
export default SvgCross;
